/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the PlayerApiConfig configuration object with a given root URL.
 */
export function providePlayerApiConfig(rootUrl: string) {
  var config = new PlayerApiConfig();
  config.rootUrl = rootUrl;
  return {
    provide: PlayerApiConfig,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class PlayerApiConfig {
  rootUrl: string = 'http://localhost:5005';
}

